import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import './OrderSummary.css';
import { getCurrentState } from '../recordDetail/states/states';
import { TYPE } from '../utility/types';

class OrderSummary extends Component {
  static get propTypes() {
    return {
      order: PropTypes.shape({
        OrderNumber: PropTypes.number,
        Client: PropTypes.string.isRequired,
        ClientBuySell: PropTypes.string,
        SummaryDescription: PropTypes.string,
        SalesPerson: PropTypes.string,
        OrderTakenTimestamp: PropTypes.string,
        ExecutionStatus: PropTypes.string.isRequired,
      }).isRequired
    };
  }

  render() {
    const currentType = TYPE.ORDER;
    const { order } = this.props;
    const { OrderNumber, Client, ClientBuySell, SummaryDescription,
      SalesPerson, OrderTakenTimestamp } = order;

    return (<div className="OrderSummary">
      <div className="RecordList-line">
        <span>
          <span>Order</span>
          <span className="OrderSummary-id">{OrderNumber}</span>
        </span>
        <span>{this.formatDate(OrderTakenTimestamp)}</span>
      </div>
      <div className="RecordList-line">
        <span className="OrderSummary-client" title={Client}>{Client}</span>
        <span className="OrderSummary-salesperson" title={SalesPerson}>{SalesPerson}</span>
      </div>
      <div className="RecordList-line">
        <span>
          <span className="OrderSummary-buysell">{ClientBuySell}</span>
          <span>-</span>
          <span title={SummaryDescription}>{SummaryDescription}</span>
        </span>
        <span className="OrderSummary-status">{getCurrentState(currentType, order)}</span>
      </div>
    </div>);
  }

  formatDate(date) {
    if (date) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '';
  }
}

export default OrderSummary;



// WEBPACK FOOTER //
// ./src/recordList/OrderSummary.js